package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_29_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Around noon, Dirk sees old stonework just off the path (100 feet). Korvis casts “Pass without a Trace,” and the heroes stealthily enter the ruins. Falorn recognizes the architecture as Dwarven, and Annette recognizes a rune. This structure might be 3000 years old, built before this region was a swamp.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth and Falorn hear the breathing of someone or something hiding nearby and smell something anomalous. The smell reminds Korvis of when he recently encountered the green Slaad. A Slaad climbs up some vines near Korvis, Bigglesworth, and Falorn. Two other Slaad sprint into the area. Bigglesworth obliterates one of the Slaad, cutting off its arm, before finishing it off. Tuesday, long vexed by fire-resistant bad mens, unleashes an explosion of poison, resembling the velocity and volume of fireball but without the heat or burning. The Slaad are dead, but the heroes worry that the danger may not be over.")
    }
}
